import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[activity-editor-host]',
    standalone: false
})
export class ActivityEditorHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
